<div class="simple-text">
  <div class="mt-1">
    <span class="signature-type-title">Assinatura Digital</span>
  </div>
  <div>{{ contact.email }}</div>
</div>
